import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M12 6V2h-1', key: '1hv4eo' }],
  [
    'path',
    {
      d: 'M9 15a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1',
      key: '1jvw5n',
    },
  ],
  ['path', { d: 'M9 21V11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10', key: 'rgi5dp' }],
];

/**
 * @component @name Podium
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNlYyaC0xIiAvPgogIDxwYXRoIGQ9Ik05IDE1YTEgMSAwIDAgMC0xLTFINGExIDEgMCAwIDAtMSAxdjVhMSAxIDAgMCAwIDEgMWgxNmExIDEgMCAwIDAgMS0xdi0zYTEgMSAwIDAgMC0xLTFoLTRhMSAxIDAgMCAwLTEgMSIgLz4KICA8cGF0aCBkPSJNOSAyMVYxMWExIDEgMCAwIDEgMS0xaDRhMSAxIDAgMCAxIDEgMXYxMCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/podium
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Podium = createLucideIcon('podium', __iconNode);

export default Podium;
